import { psAxios } from '@patsnap/common-ps-http';
import _ from 'lodash';
import { getFreeShareInitApi } from '@cores/apis/workspace_api/workspace';
import qs from 'qs';
const FREE_PATH = '/free-share';
function insertFreePath(origin, freePath) {
    const splitFullPath = origin.split('//');
    const protocol = splitFullPath.length > 1 ? splitFullPath[0] : '';
    const splitPath = splitFullPath[1].split('/');
    const domain = splitPath[0];
    const path = splitPath.filter((item, index) => index !== 0).join('/');
    return `${protocol}//${domain}${freePath}/${path}`;
}
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
const whiteListForKong = [
    // "/workspace/web/free-share/init", -- 不要忘记加在KONG里面，但是不能加在前端
    '/workspace/web/space/[^/]+/folder-list',
    '/workspace/web/space/[^/]+',
    '/workspace/web/folder/[^/]+/access',
    '/workspace/web/space/[^/]+/access',
    '/workspace/web/[^/]+/folder/[^/]+/patents',
    '/workspace/web/space/[^/]+/folder/[^/]+/init',
    '/workspace/web/folder/[^/]+/sync-field-value',
    '/workspace/web/space/detail/init',
    '/life-science-search-web/workspace/search-type',
    '/workspace/web/share-code/[^/]+',
    '/workspace/web/space/[^/]+/patent/[^/]+/preview',
    '/workspace/web/permission/user',
    '/workspace/web/permission/space/[^/]+',
    '/workspace/web/permission/space/[^/]+/folder/[^/]+',
    '/workspace/web/patent-view/sign',
];
const whiteListForJs = _.map(whiteListForKong, (item) => {
    const replaceKongRule = escapeRegExp(item.replace(/\[\^\/\]\+/g, '@'));
    const buildJsExp = replaceKongRule.replace(/@/g, '[a-zA-Z0-9_-]+') + '$';
    return new RegExp(buildJsExp);
});
function testWhiteList(url) {
    return _.some(whiteListForJs, (item) => item.test(url.split('?')[0]));
}
export const workspaceFreeInterceptor = (config) => {
    if (testWhiteList(config.url)) {
        if (!config.url.startsWith('//') && !config.url.startsWith('http')) {
            if (config.url.startsWith('/')) {
                config.url = config.url.substring(1);
            }
            config.url = `${FREE_PATH}/${config.url}`;
        }
        else {
            config.url = insertFreePath(config.url, FREE_PATH);
        }
    }
    return config;
};
export function injectWorkspaceFreeInterceptor() {
    if (!psAxios.psInterceptors.workspaceFreeInterceptor) {
        psAxios.psInterceptors.workspaceFreeInterceptor = psAxios.interceptors.request.use(workspaceFreeInterceptor, null);
    }
}
export function ejectWorkspaceFreeInterceptor() {
    psAxios.interceptors.request.eject(psAxios.psInterceptors.workspaceFreeInterceptor);
}
/**
 * 获取本地JWT token
 * @param {*} key
 * @returns
 */
export function getLocalToken(key = 'patsnap-authorizations') {
    let token = '';
    try {
        const authorizations = JSON.parse(localStorage.getItem(key) || '{}');
        if (authorizations && authorizations.token) {
            token = authorizations.token;
        }
        if (token) {
            token = `Bearer ${token}`;
        }
    }
    catch (error) {
        console.warn('getLocaleJWTToken', error);
    }
    return token;
}
export function isFreePath() {
    const isDetailPage = /^\/detail/i.test(window.location.pathname);
    const isSharePage = /\/share\//i.test(window.location.pathname);
    const query = qs.parse(window.location.search.replace('?', ''));
    if ((isDetailPage && query.spaceId) || (isSharePage && query.code)) {
        return query;
    }
}
export async function checkFreeSupported() {
    let isFree = false;
    const query = isFreePath();
    if (query) {
        let res = {};
        try {
            res = await getFreeShareInitApi({
                folder_id: query.folderId,
                space_id: query.spaceId,
                share_code: query.code,
            });
        }
        catch (error) {
            console.error('[FreeShareInit]', error);
        }
        isFree = !!res.free_share_and_free_user;
    }
    return isFree;
}
